import { FontIcon } from '../FontIcon';
import { Skeleton } from '../Skeleton';
import styles from './poster.module.sass';
import cn from 'classnames';

interface BaseProps extends React.HTMLAttributes<HTMLDivElement> {
    isLoading?: boolean;
}

interface LoadingProps extends BaseProps {
    isLoading: true;
    picture?: string; // Optional when loading
    width?: number;
    height?: number;
    alt?: string;
    inline?: boolean;
    showPlayButton?: boolean;
}

interface LoadedProps extends BaseProps {
    isLoading?: false;
    picture: string; // Required when not loading
    width?: number;
    height?: number;
    alt?: string;
    inline?: boolean;
    showPlayButton?: boolean;
}

type PosterProps = LoadingProps | LoadedProps;

export const Poster = ({ picture, width, height, alt, inline, isLoading, showPlayButton, ...props }: PosterProps) => {
    // size for inline variant
    const sizeVars = {
        ...(width ? { '--poster-w': `${width}px` } : null),
        ...(height ? { '--poster-h': `${height}px` } : null),
    } as React.CSSProperties;

    if (isLoading) {
        return (
            <div
                {...props}
                className={cn(styles.poster, props.className)}
                style={{ ...props.style, ...sizeVars }}
            >
                <Skeleton absolute />
            </div>
        );
    }

    return (
        <div
            {...props}
            className={cn(styles.poster, inline && styles.inline, props.className, props.onMouseEnter && styles.hover)}
            style={{ ...props.style, ...sizeVars }}
        >
            <img
                className={styles.picture}
                src={picture}
                alt={alt ? alt : ''}
                width={width ? width : undefined}
                height={height ? height : undefined}
            />
            {showPlayButton && <FontIcon name="play" size="size60" md="x-large" className={styles.play} />}
        </div>
    );
};
